module.exports = __webpack_public_path__ + "media/sub3-5-6.2f155b6b.mp4";